// formSlice.ts
import { RootState } from "@/src-refactor/modules/store/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  baseState,
  IValidationDocumentsObject
} from "./const/form-validation-details.const";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import getValidationDocuments from "./helpers/prepareMessageValidation";

const initialState: IValidationDocumentsObject = baseState;

export const FormValidationsDocumentsMsgSlice = createSlice({
  name: "FormValidationsDocumentsMsgSlice",
  initialState,
  reducers: {
    preloadFormValidationMsgs: (
      state,
      action: PayloadAction<IValidationDocumentsObject>
    ) => {
      return { ...state, ...action.payload }; // Correctly update the state
    },
    resetFormValidationDocMsgs: () => initialState // Add reset reducer
  }
});

export const { preloadFormValidationMsgs, resetFormValidationDocMsgs } =
  FormValidationsDocumentsMsgSlice.actions; // Export the reset action
export default FormValidationsDocumentsMsgSlice.reducer;

export const useFormValidationsDocumentsMsgSlice = () => {
  const validationDocuments = useSelector(
    (state: RootState) => state.FormValidationsDocumentsMsgSlice
  ) as IValidationDocumentsObject;

  return { validationDocuments };
};

/**
 *
 *  Hook to load the form validation messages from the property details response
 *  for details projects and properties
 *
 */
export const useLoadFormValidationMsgs = () => {
  const dispatch = useDispatch();
  const _load = useCallback((response: IPropertyDetailsResponse) => {
    const validationDocuments = JSON.parse(
      JSON.stringify(getValidationDocuments(response))
    );
    dispatch(preloadFormValidationMsgs(validationDocuments));
  }, []);

  useEffect(() => {
    addEventListener(
      "load-property",
      (state: any) => {
        _load(state.detail);
      },
      {
        once: true
      }
    );
  }, []);
  return null;
};

export const useResetFormValidationDocMsgs = () => {
  const dispatch = useDispatch();
  return () => dispatch(resetFormValidationDocMsgs());
};
